import {
  AnalyticsPageName,
  HelperTooltipWithTranslations,
  LanguageNameSpaces,
} from "@shared/types";
import { HOT_TRADES_HELPER_DESCRIPTION } from "@shared/common/constants";

export const ENTRIES_HELPER_TOOLTIP: HelperTooltipWithTranslations<LanguageNameSpaces.COMMON> =
  {
    analyticsFieldName: "Entry Strategy",
    articleLink:
      "https://intercom.help/cornix/en/articles/5814861-entry-strategy",
    analyticsPageName: AnalyticsPageName.CREATE_TRADE,
    description: "tooltips.entries",
    title: "tooltips.entries_title",
  };
export const TAKE_PROFITS_HELPER_TOOLTIP: HelperTooltipWithTranslations<LanguageNameSpaces.COMMON> =
  {
    analyticsFieldName: "Take-Profit Strategy",
    description: "tooltips.take_profits",
    articleLink:
      "https://intercom.help/cornix/en/articles/5814868-take-profit-strategy",
    analyticsPageName: AnalyticsPageName.CREATE_TRADE,
    title: "tooltips.take_profits_title",
  };
export const STOP_HELPER_TOOLTIP: HelperTooltipWithTranslations<LanguageNameSpaces.COMMON> =
  {
    analyticsFieldName: "Stop Loss strategy",
    description: "tooltips.stop_loss",
    articleLink: "",
    analyticsPageName: AnalyticsPageName.CREATE_TRADE,
    title: "tooltips.stop_loss_title",
  };
export const TRAILING_CREATE_TRADE_HELPER_TOOLTIP: HelperTooltipWithTranslations<LanguageNameSpaces.COMMON> =
  {
    analyticsFieldName: "Trailing",
    description: "tooltips.trailing",
    articleLink: "https://intercom.help/cornix/en/articles/5814927-trailing",
    analyticsPageName: AnalyticsPageName.CREATE_TRADE,
    title: "tooltips.trailing_title",
  };
export const HOT_TRADES_HELPER_TOOLTIP: HelperTooltipWithTranslations<LanguageNameSpaces.COMMON> =
  {
    analyticsPageName: "Dashboard",
    analyticsFieldName: "Hot Trades",
    title: "filters.titles.hot_trades",
    description: HOT_TRADES_HELPER_DESCRIPTION,
  };
export const TRADES_PROGRESS_HELPER_DESCRIPTION = {
  topSection: "table.trade_progress_tooltip.top_section",
  ul: [
    "table.trade_progress_tooltip.li_1",
    "table.trade_progress_tooltip.li_2",
    "table.trade_progress_tooltip.li_3",
  ],
};
/** New look: describes the price ladder that replaces the progress ring. */
export const NEW_LOOK_TRADES_PROGRESS_HELPER_DESCRIPTION = {
  topSection: "table.trade_progress_tooltip_new_look.top_section",
  ul: [
    "table.trade_progress_tooltip_new_look.li_1",
    "table.trade_progress_tooltip_new_look.li_2",
    "table.trade_progress_tooltip_new_look.li_3",
  ],
};
export const TRADE_STATUS_IN_CANCEL_HELPER_TOOLTIP: HelperTooltipWithTranslations<LanguageNameSpaces.COMMON> =
  {
    analyticsPageName: "Trade Extra Details",
    analyticsFieldName: "Waiting for cancel verification",
    description: "tooltips.trade_status_in_cancel",
    title: "tooltips.trade_status_in_cancel_title",
  };
export const TRADE_CANCEL_ON_TP_REACHED_HELPER_TOOLTIP: HelperTooltipWithTranslations<LanguageNameSpaces.TRADING_TERMINAL> =
  {
    analyticsPageName: AnalyticsPageName.TRADING_TERMINAL,
    analyticsFieldName: "Cancel on first TP target reached",
    description: "tooltips.cancel_on_tp_reached",
    title: "tooltips.cancel_on_tp_reached_title",
  };
export const SIGNAL_CANCEL_ON_TP_REACHED_HELPER_TOOLTIP: HelperTooltipWithTranslations<LanguageNameSpaces.TRADING_TERMINAL> =
  {
    ...TRADE_CANCEL_ON_TP_REACHED_HELPER_TOOLTIP,
    description: "tooltips.cancel_on_tp_reached_signal",
  };
export const INCLUDE_NEW_SYMBOLS_TOOLTIP: HelperTooltipWithTranslations<LanguageNameSpaces.BOTS> =
  {
    analyticsPageName: AnalyticsPageName.BOT_FORM,
    analyticsFieldName: "Include newly listed symbols",
    description: "helper_tooltips.form.include_new_symbols.description",
    title: "labels.include_newly_listed_symbols",
  };
